import h5 from "../h5/index.js";
import hmsapp from "../hmsapp/index.js";
import wx from "../wx/index.js";
import miniprogram from "../miniprogram/index.js";

export default {
    h5,
    hmsapp,
    wx,
    miniprogram
};